import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <>
      <footer
        className="bg-black text-gold py-6 px-4 mt-12 border-t border-gold/20"
        role="contentinfo"
        aria-label="Rodapé do site"
      >
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-white/50 text-sm">
            © {new Date().getFullYear()} Anuário AMS. Desenvolvido com ♥.
          </p>
          <nav className="mt-4" aria-label="Links do rodapé">
            <Link to="/privacy" className="text-gold hover:underline px-2">Política de Privacidade</Link>
            <span className="text-white/30" aria-hidden="true">|</span>
            <Link to="/terms" className="text-gold hover:underline px-2">Termos de Uso</Link>
          </nav>
        </div>
      </footer>
      <style>{`
        @media (max-width: 768px) {
          footer {
            font-size: 0.95rem;
          }
          .max-w-4xl {
            max-width: 100vw;
            padding: 0 4px;
          }
          .mt-4 {
            margin-top: 0.5rem;
          }
        }
      `}</style>
    </>
  );
};

export default Footer;